<template>
  <div class="wizard-group">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "WizardGroup",
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";

.wizard-group {
  &.-margin-md {
    margin-bottom: 40px;
    @include mq-up(md) {
      margin-bottom: 60px;
    }
  }
  :deep(> .sub-wizard) {
    margin-top: 20px;
    @include mq-up(md) {
      margin-top: 40px;
    }
  }
}
</style>
